<!-- 图书柜-卖书-扫描条码 -->
<template>
  <div class="BookcaseSScanCode">
    <div class="box">
      <img class="icon" src="/static/Bookcase/images/icon_scan.png" alt="">
      <p class="hint">请对着扫码枪扫描商品上的条码</p>
      <!-- <CountDown :time=120 beforeText="请在" afterText="s内完成操作"></CountDown> -->
    </div>
    <!-- mqtt  -->
    <Mqttws ref="mqttws" :topic="topic" msgIsHex @getMessage="getMessage"></Mqttws>
   
  </div>
</template>

<script>
  import CountDown from '@/components/Bookcase/Common/CountDown' // 倒计时
  import Dialog from '@/components/Bookcase/Common/Dialog'       // 对话框
  import Mqttws from '@/components/Bookcase/Common/Mqttws'
  import { storage, messageError, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { checkData, hex_to_ten, hexCharCodeToStr } from '../../../../static/js/utils/util'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
import { showToast } from '../../../../static/turnoverCabinet/js/utility';
  let vm

  export default {
    name:'BookcaseSScanCode',
    components: {
      CountDown,
      Dialog,
      Mqttws
    },
    computed: {
    },
    data() {
      return {
        topic: '/'+ config.deviceId + '/report/' + config.serverPort2 + '/environment/protocol',  // 硬件扫码枪主动上报主题
        topic2: '/'+ config.serverPort2 + '/down/' + config.deviceId + '/control/protocol/response', // 前端推送主题（发送打印指令）

        // openSuccess: false,
        // printSuccess: false,
      }
    },
    created() {
      vm = this
      console.log('vm.$store.state.ECMall_activeGoods', vm.$store.state.ECMall_activeGoods)
    },
    mounted () {
    },
    methods: {
      // 获取mqtt信息
      getMessage (data) {
        console.log('mqtt返回信息：', data)
        if (data) {
          vm.processData(data)
        }
      },
      // 数据处理
      processData (data) {
        console.log('data', data, data.length)
        let dataLen = data.length
        let str = data.substring(2,dataLen-2);//截取字符串的第二到倒数第二的数据
        let num = checkData(str)
        let bbc = data.substr(dataLen-2)
        // 校验bbc是否正确
        if (num == bbc) {
          let dataType = data.substring(4,6)  // 数据流
          let func = data.substring(28, 32)   // 功能码
          let dlen = hex_to_ten(data.substring(32, 36)) // 有效数据长度
          console.log('dataType', dataType)
          console.log('数据长度', dlen)
          // 接收到的上报商品条码
          if (dataType == 'ab' && func == 'ab01') {
            let sn = hexCharCodeToStr(data.substring(36, dataLen-2))
            let activeGoods = vm.$store.state.ECMall_activeGoods
            console.log('扫码枪返回sn', sn, sn.length)
            console.log('选中商品sn', activeGoods.sn, activeGoods.sn.length)
            // console.log('tag', sn == activeGoods.sn)
            // 确认是要出售的这个商品（开箱存物）
            if (sn == activeGoods.sn) {
              // 发送打印指令给打印机，并开箱
              showLoading('正在打印商品码、开启箱门，请稍等...')
              vm.subPrint()
              vm.openBox()
            } else {
              messageError('当前书籍和选中上架的商品不符,请扫描正确的商品')
            }
          // 获取打印机打印条码的状态(55成功，aa失败)
          } else if (dataType == 'aa' && func == '2c42') {
            let status = data.substring(dataLen-4, dataLen-2)
            if (status == '55') {
              console.log('打印成功', '')
            } else {
              messageError('打印失败，请点击右下方按钮联系客服')
            }
          }
        }
      },
      // 发送打印指令
      async subPrint () {
        let activeGoods = vm.$store.state.ECMall_activeGoods
        let data = {
          pid: activeGoods.pid,
          cabinet_id: config.deviceId
        }

        let res = await ECMallApi.subPrint(data)
        if (res.meta.code === 200) {
          console.log('发送打印指令成功', '')
          // vm.$refs.mqttws.onConnect(vm.topic2)
          // vm.$refs.mqttws.send(vm.topic2)
        } else {
          messageError(res.meta.message)
        }
      }, 
      // 开箱（卖书开箱存物为1）
      async openBox () {
        let data = {
          type: 1,
          cabinet_id: config.deviceId,
          pid: vm.$store.state.ECMall_activeGoods.pid
        }

        console.log(data)
        let res = await ECMallApi.openBox(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log(res)
          vm.$router.push('/Bookcase/SOpenBox')
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },
      // 去支付
      goOpenBox () {
        vm.$router.push('/Bookcase/PayList')
      },
      // 去支付
      goPay () {
        if (vm.isScanCodePage) { return }
        vm.$router.push('/Bookcase/Pay')
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseSScanCode {
    width: 100%;
    height: 100%;
    padding: 0.52rem 0.42rem 0.54rem;
    display: flex;
    flex-direction: column;
    .box {
      width: 9.42rem;
      height: 100%;
      margin: 0 auto;
      padding-top: 3.6rem;
      background-color: #ffffff;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      .icon {
        display: block;
        width: 1.83rem;
        height: 1.62rem;
        margin: 0 auto;
      }
      .hint {
        margin: 0.9rem auto 0;
        font-size: 0.4rem;
        line-height: 0.57rem;
        font-weight: bold;
        text-align: center;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Sell/SScanCode.vue